import { render, staticRenderFns } from "./widgetSearch.vue?vue&type=template&id=6cbe00e2&scoped=true"
import script from "./widgetSearch.vue?vue&type=script&lang=js"
export * from "./widgetSearch.vue?vue&type=script&lang=js"
import style0 from "./widgetSearch.vue?vue&type=style&index=0&id=6cbe00e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe00e2",
  null
  
)

export default component.exports